import React, {useReducer} from 'react';
import {Checkbox, InputItem, List, Switch} from "antd-mobile";
import {includes, map} from 'lodash';
import {fieldReducer} from "../lib/utils";
import {useDebouncedEffect} from "../lib/hooks";

const CheckboxItem = Checkbox.CheckboxItem;

//TODO CheckboxGroup controlled component
const data = [
    { value: 'print', label: 'Print' },
    { value: 'web', label: 'Web' }
];

const allMediums = map(data, 'value');


//NOTE this is not a form (rename) - changes picked up after 1sec debouce

export default function QueryForm(
    {
        company, onChange=()=>{},
        defaultKeyword, showHolidayToggle=false,
        ...props})
{
    const [query, updateQuery] = useReducer(fieldReducer, {
        keyword: defaultKeyword,
        exactMatch: false,
        holidayOnly: false,
        medium: allMediums
    });

    const replaceKeyword = (value) => {
        updateQuery({
            field: 'keyword',
            type: 'replace',
            value
        });
    };

    const changeMedium = (checked, value) => {
     updateQuery({
            field: 'medium',
            type: checked ? 'add' : 'remove',
            value
        });
    };

    const toggleField = (field) => {
        updateQuery({
            field ,
            type: 'replace',
            value: !query[field]
        });
    };

    /* not needed now we reset on any company change
    useDebouncedEffect(()=>{
        console.log(`KW: ${query.keyword} def: ${defaultKeyword}`);
        if (query.keyword===''){
            replaceKeyword(defaultKeyword);
        }
    },1000,[defaultKeyword, query]);
     */


    useDebouncedEffect(()=>{
        onChange(query);
    },1000, [query]);


    return (
        <List {...props} >
            <InputItem
                value={query.keyword}
                name={'keyword'}
                onChange={replaceKeyword}
                    >Keywords: </InputItem>
            <List.Item
                name={'exactMatch'}
                extra={<Switch
                    checked={query.exactMatch}
                    onChange={() => toggleField('exactMatch')}
                />}
            >Exact match</List.Item>
            {showHolidayToggle && <List.Item
                name={'holidayOnly'}
                extra={<Switch
                    checked={query.holidayOnly}
                    onChange={() => toggleField('holidayOnly')}
                />}
            >Holiday Service only:</List.Item>}
            <List.Item >Medium:
            {data.map(i => (
                <CheckboxItem
                    key={i.value}
                    checked={includes(query.medium, i.value)}
                    onChange={(e) => changeMedium(e.target.checked, i.value)}
                    className={'inline-flex'}
                >
                    {i.label}
                </CheckboxItem>
            ))}
            </List.Item>
        </List>
    );
};
